<template>
  <div class="smaller-container-wrapper full-height">
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <h2 class="mb-3 mb-sm-4">{{ $t('message.eCommerceV2.tradeInFlow.autoComplete.heading') }}</h2>
      <trade-auto-complete
        v-model="vehicleSelected"
        :valueObject="selectedVehicleObject"
        :label="$t('message.credit.application.tradeInVehicle.yearMakeModel')"
        @selectedVehicleObject="selectedTradeVehicle"
      >
      </trade-auto-complete>
      <div class="push-down-desktop">
        <mobialis-button
          type="submit"
          class="mt-5"
          :class="[currentSubFlow !== 'trade-in' ? 'mb-2' : 'mb-3']"
          data-cy="continue"
          >{{ $t('message.common.continue') }}</mobialis-button
        >
        <mobialis-button
          v-if="currentSubFlow !== 'trade-in'"
          variant="link"
          @click="skipTrade"
          data-cy="skipTrade"
          v-av-analytics-cta-interaction="{
            elementText: $t('message.eCommerceV2.tradeInFlow.skipTrade'),
            eventActionResult: 'open',
          }"
        >
          {{ $t('message.eCommerceV2.tradeInFlow.skipTrade') }}
        </mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TradeAutoComplete from '@/components/shared/TradeAutoComplete.vue';

export default {
  components: { TradeAutoComplete },
  name: 'TradeInAutocomplete',
  data() {
    return {
      vehicleSelected: '',
      selectedVehicleObject: {},
    };
  },
  computed: {
    ...mapGetters({
      getVehicleName: 'trade/getVehicleName',
      getBaseVehicleObject: 'trade/getBaseVehicleObject',
    }),
  },
  mounted() {
    this.vehicleSelected = this.getVehicleName;
    this.selectedVehicleObject = this.getBaseVehicleObject;
  },
  methods: {
    submit(isValid) {
      if (!isValid) {
        return;
      }
      this.$store.commit('trade/SET_VEHICLE', this.selectedVehicleObject);
      this.$store.commit('trade/SET_LEAD_TRADEIN_VEHICLE');
      this.$router.push({ path: this.getNextRoutePath() });
    },
    skipTrade() {
      // only visible the personalized payments main flow and make an offer flow
      // reset state related to trade in
      this.$store.commit('trade/RESET_VEHICLE');
      this.$store.commit('paymentCalculator/REMOVE_TRADE');
      if (this.ecomFlowSelected === 'personalized-payment') {
        this.$router.push({ path: 'contact-info-form' });
      } else {
        this.$router.push({ path: 'payment-calculator' });
      }
    },
    selectedTradeVehicle(vehicle) {
      this.selectedVehicleObject = vehicle;
    },
  },
};
</script>
<style lang="scss"></style>
